// extracted by mini-css-extract-plugin
module.exports = {"tHead":"EmployeeType_tHead__3Lcy5"};